<div class="tabbassiCard card">
  <div class="card-header">
    <span>{{ "HOME.STARTER_SEARCH" | translate }}</span>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col">
        <div class="p-inputgroup">
          <input
            pInputText
            type="text"
            class="border-right-0"
            placeholder="{{ 'HOME.SEARCH' | translate }}"
          />
          <span class="p-inputgroup-addon bg-white border-left-0 c-p"
            ><i class="pi pi-search"></i
          ></span>
        </div>
      </div>
    </div>
  </div>
</div>
